import React from 'react';
import { Image, Text } from '@chakra-ui/react';
import Plugin, { PluginProps } from '../Plugin';

const Picture = (props: PluginProps) => {
  const { content } = props;
  if (!content.data.src) {
    return null;
  }
  const imageProps = content.data.props;
  if (imageProps.alignment) {
    if (imageProps.alignment === 'right') {
      imageProps.marginLeft = 'auto';
      imageProps.marginRight = 0;
    } else if (imageProps.alignment === 'left') {
      imageProps.marginRight = 'auto';
      imageProps.marginLeft = 0;
    } else {
      imageProps.marginLeft = 'auto';
      imageProps.marginRight = 'auto';
    }
  }
  const captionText = imageProps.caption_text;
  const linkUrl = imageProps.link_url;
  const ImageComponent = () => (
    <figure>
      <Image style={{ ...imageProps }} src={content.data.src} />
      <Text
        as="figcaption"
        size="sm"
        style={{ textAlign: imageProps.alignment }}
      >
        {captionText}
      </Text>
    </figure>
  );
  if (linkUrl) {
    return (
      <a href={linkUrl}>
        <ImageComponent />
      </a>
    );
  }
  return <ImageComponent />;
};

export default Picture;
